import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { router } from './App';
import AuthContextProvider from './core/auth/AuthContextProvider';
import { MantineProvider } from '@mantine/core';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { mantineDpkkTheme } from './core/style/MantineDpkkTheme';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import './styles.css';
import { ModalsProvider } from '@mantine/modals';
import { DatabaseLockProvider } from './core/database-lock/DatabaseLockProvider';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// [DAP-021] Datumové filtry v tabulce používají u MUI X DatePickeru `timezone: 'Europe/Prague'`.
// MUI X pak nad hodnotou volá `value.isUTC()`, což je metoda z dayjs pluginu `utc` (a `timezone`
// na něm staví). Bez načtení těchto pluginů picker při vykreslení neprázdné hodnoty spadl na
// „value.isUTC is not a function" a filtr se nedal nastavit (a tím se ani neposlal na backend →
// zdánlivě „všechny záznamy"). Pluginy proto registrujeme globálně jednou při startu aplikace.
dayjs.extend(utc);
dayjs.extend(timezone);

const rootElement = document.getElementById('root') as Element;
const root = createRoot(rootElement);

root.render(
  <MantineProvider theme={mantineDpkkTheme}>
    <ModalsProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <StrictMode>
          <AuthContextProvider>
            <DatabaseLockProvider>
              <RouterProvider router={router} />
            </DatabaseLockProvider>
          </AuthContextProvider>
        </StrictMode>
      </LocalizationProvider>
    </ModalsProvider>
  </MantineProvider>
);
